module.exports = __webpack_public_path__ + "img/EUROPE_1.f30ab090.webp";